import { render, staticRenderFns } from "./DisplayStoreItemsList.vue?vue&type=template&id=7ef1b215&"
import script from "./DisplayStoreItemsList.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsList.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsList.vue?vue&type=style&index=0&id=7ef1b215&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports